export type LlmModelCategory = 'chat' | 'multimodal' | 'image'

export interface LlmModelArchitecture {
  modality: string
  inputModalityList: string[]
  outputModalityList: string[]
  tokenizer: string
  instructType: string | null
}

export interface LlmModelTopProvider {
  contextLength: number
  maxCompletionTokens: number | null
  isModerated: boolean
}

export interface LlmModelPricing {
  prompt: string
  completion: string
  request: string
  image: string
  webSearch: string
  internalReasoning: string
  inputCacheRead: string | null
  inputCacheWrite: string | null
}

export interface LlmModel {
  id: string
  name: string
  description: string
  contextLength: number
  architecture: LlmModelArchitecture
  topProvider: LlmModelTopProvider
  pricing: LlmModelPricing
  created: number
}

export interface LlmModelsResponse {
  models: LlmModelRawApiItem[]
  total: number
}

type LlmModelRawApiItem = Record<string, unknown>

export const transformLlmModelFromApi = (apiModel: LlmModelRawApiItem): LlmModel => {
  const architecture = apiModel.architecture as Record<string, unknown>
  const topProvider = apiModel.top_provider as Record<string, unknown>
  const pricing = apiModel.pricing as Record<string, unknown>

  return {
    id: apiModel.id as string,
    name: apiModel.name as string,
    description: apiModel.description as string,
    contextLength: apiModel.context_length as number,
    architecture: {
      modality: architecture.modality as string,
      inputModalityList: architecture.input_modalities as string[],
      outputModalityList: architecture.output_modalities as string[],
      tokenizer: architecture.tokenizer as string,
      instructType: architecture.instruct_type as string | null,
    },
    topProvider: {
      contextLength: topProvider.context_length as number,
      maxCompletionTokens: topProvider.max_completion_tokens as number | null,
      isModerated: topProvider.is_moderated as boolean,
    },
    pricing: {
      prompt: pricing.prompt as string,
      completion: pricing.completion as string,
      request: pricing.request as string,
      image: pricing.image as string,
      webSearch: pricing.web_search as string,
      internalReasoning: pricing.internal_reasoning as string,
      inputCacheRead: pricing.input_cache_read as string | null,
      inputCacheWrite: pricing.input_cache_write as string | null,
    },
    created: apiModel.created as number,
  }
}
